export default "__VITE_ASSET__DQohx9Ak__"